import React from 'react';

const ConversationMonitor = ({ 
  conversations, 
  activeConversation, 
  onSelectConversation, 
  onRefresh 
}) => {
  
  return (
    <div className="conversation-monitor">
      <div className="monitor-header">
        <h3>💬 Conversations</h3>
        <button onClick={onRefresh} className="refresh-btn">
          🔄 Refresh
        </button>
      </div>

      <div className="conversation-list">
        {conversations.length === 0 ? (
          <div className="no-conversations">
            <p>No conversations yet</p>
            <p>Create one to get started!</p>
          </div>
        ) : (
          conversations.map((conv) => (
            <div 
              key={conv.id || `conv-${Math.random()}`}
              className={`conversation-item ${activeConversation?.id === conv.id ? 'active' : ''}`}
              onClick={() => onSelectConversation(conv)}
            >
              <div className="conv-info">
                <div className="conv-name">{conv.session_name || 'Unnamed'}</div>
                <div className="conv-id">ID: {conv.id ? conv.id.substring(0, 8) : 'No ID'}...</div>
                <div className="conv-status">
                  <span className={`status-dot ${conv.status}`}>●</span>
                  {conv.status}
                </div>
              </div>
              <div className="conv-actions">
                <button 
                  onClick={(e) => {
                    e.stopPropagation();
                    window.open(conv.url, '_blank');
                  }}
                  className="open-btn"
                >
                  🔗
                </button>
              </div>
            </div>
          ))
        )}
      </div>

      {activeConversation && (
        <div className="active-conversation-details">
          <h4>📍 Active Conversation</h4>
          <div className="details">
            <p><strong>Name:</strong> {activeConversation.session_name || 'Unnamed'}</p>
            <p><strong>ID:</strong> {activeConversation.id}</p>
            <p><strong>Status:</strong> {activeConversation.status}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ConversationMonitor;